import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { androidScreenMarginBottom } from 'utils/responsiveness';

const styles = StyleSheet.create({
    modal: {
        flex: 1,
        backgroundColor: COLOR.background,
        marginBottom: androidScreenMarginBottom,
    },
    scroll: {
        flex: 1,
        paddingBottom: 24,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
    },
    backgroundStyle: {
        backgroundColor: COLOR.background,
    },
});

export default styles;
